'use strict';/* global define:false */define('helen/services/requests',['angular','util/array-remove'],function(ng,remove){'use strict';function feedbackData(note){return{noteLevelConfigId:note.score.id,text:note.text};}function service(Request){// jshint validthis:true
function requestResponse(type,subtype,request,requests,action){var method=action==='accept'?'save':'delete';var params={type:type,subtype:subtype,id:request[type]?request[type].id:request.id,userId:request.requester?request.requester.id:null,action:action};var resource=Request[method](params,null);resource.$promise.then(function(){remove(requests,request);});return resource;}function requestAccept(type,subtype,request,requests){return requestResponse(type,subtype,request,requests,'accept');}function requestDecline(type,subtype,request,requests){return requestResponse(type,subtype,request,requests,'decline');}function requestCancel(type,subtype,request,requests){return requestResponse(type,subtype,request,requests,'cancel');}//////////////
// training //
//////////////
// list all the training requests
this.training=function(id){return Request.query({type:'training',id:id,action:'pending'});};this.training.create=function(id){return Request.save({type:'training',id:id},null);};// this.training.request = function () {
// }
// approve the training request
this.training.accept=function(request,requests){return requestAccept('training',null,request,requests);};// decline the training request
this.training.decline=function(request,requests){return requestDecline('training',null,request,requests);};// cancel the training request
this.training.cancel=function(request,requests){return requestCancel('training',null,request,requests);};//////////////
// feedback //
//////////////
// function requestFeedback( subtype, userId, request ) {
//   return Request.save({
//     type    : 'feedback',
//     subtype : subtype,
//     userId  : userId
//   }, request );
// }
// this.feedback = {};
// // list all the 360 feedback requests
// this.feedback.threeSixty = function () {
//   return Request.query({
//     type    : 'feedback',
//     subtype : 'three-sixty'
//   });
// };
// // send a 360 feedback request about user[id:userId]
// this.feedback.threeSixty.send = function ( userId, request ) {
//   return requestFeedback( 'three-sixty', userId, request );
// };
// this.feedback.threeSixty.accept = function ( request, feedback ) {
//   var resource = Request.save({
//     type    : 'feedback',
//     subtype : 'three-sixty',
//     id      : request.id,
//     action  : 'accept'
//   }, feedbackData( feedback ) );
//   // resource.$promise
//   //   .then( function () {
//   //     remove( requests, request );
//   //   });
//   return resource;
// };
// this.feedback.threeSixty.decline = function ( request, requests ) {
//   // return requestDecline( 'feedback', 'three-sixty', request, requests );
//   var resource = Request.delete({
//     type    : 'feedback',
//     subtype : 'three-sixty',
//     id      : request.id,
//     action  : 'decline'
//   }, null );
//   resource.$promise
//     .then( function () {
//       remove( requests, request );
//     });
//   return resource;
// };
}return['Request',service];});
